import { useEffect, useState } from 'react';
import { api } from '../../../api/client';
import styles from './GradesPage.module.css';

export default function GradesPage() {
  const [students, setStudents] = useState<any[]>([]);
  const [records, setRecords] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedStudent, setSelectedStudent] = useState('');
  const [form, setForm] = useState({ subject: '', grade: '', period: '2024-2025', comments: '' });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const fetchData = async () => {
    setLoading(true);
    try {
      const [sData, rData] = await Promise.all([
        api.get('/api/students'),
        api.get('/api/attendance/academic-records'),
      ]);
      if (Array.isArray(sData)) setStudents(sData);
      if (Array.isArray(rData)) setRecords(rData);
    } catch {}
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedStudent) return;
    setSaving(true);
    setMessage('');
    try {
      await api.post('/api/attendance/academic-records', {
        studentId: selectedStudent,
        subject: form.subject,
        grade: parseFloat(form.grade),
        period: form.period,
        comments: form.comments,
      });
      setMessage('Calificación registrada');
      setForm({ subject: '', grade: '', period: '2024-2025', comments: '' });
      fetchData();
    } catch (err: any) {
      setMessage(err.message);
    }
    setSaving(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Expediente Académico</h1>
      </div>
      <div className={styles.card}>
        <h2>Registrar Calificación</h2>
        {message && (
          <div className={message.includes('Error') ? styles.errorMsg : styles.successMsg}>
            {message}
          </div>
        )}
        <form onSubmit={handleSubmit} className={styles.form}>
          <select
            value={selectedStudent}
            onChange={(e) => setSelectedStudent(e.target.value)}
            required
          >
            <option value="">Seleccionar Alumno</option>
            {students.map((s: any) => (
              <option key={s.id} value={s.id}>
                {s.paternalLastName}, {s.firstName}
              </option>
            ))}
          </select>
          <input
            placeholder="Materia"
            value={form.subject}
            onChange={(e) => setForm({ ...form, subject: e.target.value })}
            required
          />
          <div className={styles.row}>
            <input
              type="number"
              step="0.1"
              placeholder="Calificación (0-100)"
              value={form.grade}
              onChange={(e) => setForm({ ...form, grade: e.target.value })}
              required
            />
            <input
              placeholder="Periodo"
              value={form.period}
              onChange={(e) => setForm({ ...form, period: e.target.value })}
              required
            />
          </div>
          <input
            placeholder="Comentarios (opcional)"
            value={form.comments}
            onChange={(e) => setForm({ ...form, comments: e.target.value })}
          />
          <button type="submit" disabled={saving} className={styles.submitBtn}>
            {saving ? 'Guardando...' : 'Registrar'}
          </button>
        </form>
      </div>
      <div className={styles.tableCard}>
        <h2>Historial</h2>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Alumno</th>
              <th>Materia</th>
              <th>Periodo</th>
              <th>Calificación</th>
              <th>Comentarios</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5}>Cargando...</td>
              </tr>
            ) : records.length === 0 ? (
              <tr>
                <td colSpan={5}>Sin registros</td>
              </tr>
            ) : (
              records.map((r: any) => (
                <tr key={r.id}>
                  <td>
                    {r.student?.paternalLastName}, {r.student?.firstName}
                  </td>
                  <td>{r.subject}</td>
                  <td>{r.period}</td>
                  <td>
                    <strong>{r.grade}</strong>
                  </td>
                  <td style={{ color: '#999', fontSize: '0.85rem' }}>{r.comments || '--'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
